/* EXAMPLE

const range = [
  { value: 0, step: 1},
  { value: 20, step: 5 },
  { value: 100 }
]

const Range = configureRange(range)

Range.minStep // 0
Range.maxStep // 36
Range.getValueForStep(22) // 30
Range.getStepForValue(30) // 22

*/
const DEFAULT_RANGE_STEP = 1;
const DEFAULT_RANGE_VALUE = 0;
const sortBy = (key) => (a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
export const getBlockValuePercentage = (breakpoints) => {
    const DEFAULT_BLOCK_VALUE_PERCENTAGE = 100;
    let blockValue;
    try {
        blockValue = DEFAULT_BLOCK_VALUE_PERCENTAGE / (breakpoints.length - 1);
        if (!isFinite(blockValue)) {
            throw new Error('Invalid division');
        }
    }
    catch (error) {
        blockValue = DEFAULT_BLOCK_VALUE_PERCENTAGE;
    }
    return blockValue;
};
export const configureRange = (range) => {
    const sorted = range.concat().sort(sortBy('value'));
    const blockValuePercentage = getBlockValuePercentage(sorted);
    const rangeControl = {};
    const breakpoints = sorted.reduce((result, curr, key) => {
        const prev = sorted[key - 1];
        const next = sorted[key + 1];
        const stepsInRange = (next ? next.value - curr.value : curr.value) / (curr.step || DEFAULT_RANGE_STEP);
        rangeControl[curr.value] = {};
        rangeControl[curr.value]['steps'] = stepsInRange;
        rangeControl[curr.value]['index'] = blockValuePercentage / stepsInRange;
        rangeControl[curr.value]['start'] = blockValuePercentage * key;
        rangeControl[curr.value]['startStep'] = prev
            ? (curr.value - prev.value) / (prev.step || DEFAULT_RANGE_STEP) + rangeControl[prev.value].startStep
            : 0;
        if (typeof curr.step === typeof undefined) {
            curr.step = 1;
        }
        result.push(curr);
        return result;
    }, []);
    const firstBreakPoint = breakpoints[0];
    const lastBreakPoint = breakpoints.slice(-1)[0];
    const firstRangeControl = rangeControl[firstBreakPoint.value];
    const lastRangeControl = rangeControl[lastBreakPoint.value];
    const { startStep: minStep } = firstRangeControl;
    const { startStep: maxStep } = lastRangeControl;
    const { value: minValue } = firstBreakPoint;
    const { value: maxValue } = lastBreakPoint;
    const ensureValue = (value) => {
        if (value > maxValue) {
            return maxValue;
        }
        else if (value < minValue) {
            return minValue;
        }
        else {
            return value;
        }
    };
    const getValueForStep = (step) => {
        const nearest = getNearest(step, 'startStep');
        const additionalValue = (step - rangeControl[nearest.value].startStep) * (nearest.step || DEFAULT_RANGE_STEP);
        return nearest.value + additionalValue;
    };
    const getNearest = (compareValue, rangeControlKey) => breakpoints.reduce((prev, curr) => rangeControl[curr.value][rangeControlKey] < compareValue &&
        rangeControl[curr.value][rangeControlKey] >=
            rangeControl[prev.value || DEFAULT_RANGE_VALUE][rangeControlKey]
        ? curr
        : prev, firstBreakPoint);
    const getStepForPercentagePosition = (percentagePosition) => {
        const nearest = getNearest(percentagePosition, 'start');
        const additionalStep = Math.round((percentagePosition - rangeControl[nearest.value].start) / rangeControl[nearest.value].index);
        return rangeControl[nearest.value].startStep + additionalStep;
    };
    const getStepForValue = (value) => {
        const nearest = breakpoints.reduce((prev, curr) => (curr.value < value && curr.value > prev.value ? curr : prev), firstBreakPoint);
        const additionalSteps = (value - nearest.value) / (nearest.step || DEFAULT_RANGE_STEP);
        return rangeControl[nearest.value].startStep + additionalSteps;
    };
    const getLeftFromCurrentStep = (step) => {
        const nearest = getNearest(step, 'startStep');
        const block = rangeControl[nearest.value];
        const additionalValue = step - rangeControl[nearest.value].startStep;
        return block.start + additionalValue * block.index;
    };
    const getRangeSteps = () => {
        const rangeSteps = [];
        Object.keys(rangeControl).map((key) => {
            rangeSteps.push(rangeControl[key].start);
        });
        return rangeSteps;
    };
    return {
        minStep,
        maxStep,
        minValue,
        maxValue,
        ensureValue,
        getValueForStep,
        getStepForValue,
        getLeftFromCurrentStep,
        getRangeSteps,
        getStepForPercentagePosition,
    };
};
